import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Me } from '@xingternal/platform-layout-me';

import { NavList } from './nav-list';
import styles from './SideBar.css';

const SideBar = ({ hasUser }) => (
  <nav className={styles.nav}>
    {hasUser && (
      <Me
        className={cx(styles.me, styles.expanded)}
        patternId="vertical-navigation-expanded"
      />
    )}
    {hasUser && (
      <Me
        className={cx(styles.me, styles.collapsed)}
        collapsed
        patternId="vertical-navigation-collapsed"
      />
    )}
    <NavList placeholders={12} />
  </nav>
);

SideBar.displayName = 'SideBar';

SideBar.propTypes = {
  hasUser: PropTypes.bool.isRequired,
};

export { SideBar };
